import { Box } from "@bca/ui-library";

import Deliveries from "../Options/Deliveries";
import Export from "../Options/Export";

import type { ISundryMessages } from "../../VehicleCard/TransportModalSundryMessages";

interface DeliveryCardsProps {
  transportModalData: any;
  bookDeliveryOnClickHandler: () => void;
  bookExportDeliveryOnClickHandler: () => void;
  callCustomerServiceOnClickHandler: () => void;
  emailCustomerServiceOnClickHandler: () => void;
  exportFlag: boolean;
  sundryMessages: ISundryMessages;
  isLateStorageFees?: boolean;
}

const DeliveryCards: React.FunctionComponent<DeliveryCardsProps> = ({
  transportModalData,
  bookDeliveryOnClickHandler,
  bookExportDeliveryOnClickHandler,
  callCustomerServiceOnClickHandler,
  emailCustomerServiceOnClickHandler,
  exportFlag,
  sundryMessages,
  isLateStorageFees = false
}) => {
  return (
    <Box mt={32}>
      <Box>
        <Deliveries
          requestDeliveryLink={transportModalData.requestDeliveryLink}
          isEnabled={transportModalData.isEligibleForDelivery}
          bookDeliveryOnClickHandler={bookDeliveryOnClickHandler}
          callCustomerServiceOnClickHandler={callCustomerServiceOnClickHandler}
          emailCustomerServiceOnClickHandler={
            emailCustomerServiceOnClickHandler
          }
          sundryMessage={sundryMessages.deliveryAlert}
          isLateStorageFees={isLateStorageFees}
        />
      </Box>
      <Box mt={32}>
        <Export
          isVisible={exportFlag}
          requestDeliveryExportLink={
            transportModalData.requestDeliveryExportLink
          }
          bookExportDeliveryOnClickHandler={bookExportDeliveryOnClickHandler}
        />
      </Box>
    </Box>
  );
};

export default DeliveryCards;
